"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('providers/ajaxSettingsProvider',["require", "exports", "store/tokenStore", "models/userIdentityModel"], function (require, exports, tokenStore, userIdentityModel) {
    "use strict";

    var AjaxSettingsProvider = function () {
        function AjaxSettingsProvider() {
            _classCallCheck(this, AjaxSettingsProvider);

            this.refreshingToken = false;
            //this.refreshingTokenDeferred = $.Deferred().resolve();
        }

        _createClass(AjaxSettingsProvider, [{
            key: "httpDelete",
            value: function httpDelete() {
                var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getBearerHeader();

                return this.httpNoData('DELETE', headers);
            }
        }, {
            key: "httpGet",
            value: function httpGet() {
                var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getBearerHeader();

                return this.httpNoData('GET', headers);
            }
        }, {
            key: "httpHead",
            value: function httpHead() {
                var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getBearerHeader();

                return this.httpNoData('HEAD', headers);
            }
        }, {
            key: "httpOptions",
            value: function httpOptions() {
                var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getBearerHeader();

                return this.httpNoData('OPTIONS', headers);
            }
        }, {
            key: "httpPostJson",
            value: function httpPostJson(data, timeout) {
                var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getBearerHeader();

                return this.httpDataJson('POST', headers, data, timeout);
            }
        }, {
            key: "httpPost",
            value: function httpPost(data, timeout) {
                var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.getBearerHeader();

                return this.httpData('POST', headers, data, timeout);
            }
        }, {
            key: "httpPut",
            value: function httpPut(data) {
                var headers = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getBearerHeader();

                return this.httpData('PUT', headers, data);
            }
        }, {
            key: "httpTrace",
            value: function httpTrace() {
                var headers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getBearerHeader();

                return this.httpNoData('TRACE', headers);
            }
        }, {
            key: "getBearerHeader",
            value: function getBearerHeader() {
                return { 'Authorization': 'Bearer ' + tokenStore.getAccessToken() };
            }
        }, {
            key: "httpDataJson",
            value: function httpDataJson(type, headers, data, timeout) {
                var refreshingTokenDeferred = $.Deferred().resolve();
                var settings = {
                    type: type,
                    contentType: 'application/json; charset=utf-8',
                    processData: false
                };
                if (headers) {
                    settings.headers = headers;
                    settings.headers['sessionid'] = userIdentityModel.sessionId();
                }
                if (data) {
                    settings.data = JSON.stringify(data);
                    settings.timeout = timeout || 120000;
                }
                return {
                    settings: settings,
                    refreshTokePromise: refreshingTokenDeferred.promise()
                };
            }
        }, {
            key: "httpData",
            value: function httpData(type, headers, data, timeout) {
                var refreshingTokenDeferred = $.Deferred().resolve();
                var settings = { type: type };
                if (headers) {
                    settings.headers = headers;
                    settings.headers['sessionid'] = userIdentityModel.sessionId();
                }
                if (data) {
                    settings.data = data;
                    settings.timeout = timeout || 120000;
                }
                return {
                    settings: settings,
                    refreshTokePromise: refreshingTokenDeferred.promise()
                };
            }
        }, {
            key: "httpNoData",
            value: function httpNoData(type, headers) {
                var refreshingTokenDeferred = $.Deferred().resolve();
                var settings = { type: type, cache: false };
                if (headers) {
                    settings.headers = headers;
                    settings.headers['sessionid'] = userIdentityModel.sessionId();
                }
                settings.timeout = 120000;
                return {
                    settings: settings,
                    refreshTokePromise: refreshingTokenDeferred.promise()
                };
            }
        }, {
            key: "secondsAgo",
            value: function secondsAgo(date) {
                return (new Date().getTime() - date.getTime()) / 1000;
            }
        }]);

        return AjaxSettingsProvider;
    }();

    return new AjaxSettingsProvider();
});
//# sourceMappingURL=ajaxSettingsProvider.js.map;
